import { motion } from "framer-motion";
import { Reveal } from "./Reveal";

export const MaskedWords = ({ text }: { text: string }) => (
  <motion.span
    initial="hidden"
    whileInView="visible"
    viewport={{ once: true, margin: "-40px" }}
    variants={{ visible: { transition: { staggerChildren: 0.06 } } }}
  >
    {text.split(" ").map((word, i) => (
      <span key={i} className="inline-block overflow-hidden pb-1 align-bottom">
        <motion.span
          className="inline-block"
          variants={{
            hidden: { y: "110%" },
            visible: {
              y: 0,
              transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] },
            },
          }}
        >
          {word}&nbsp;
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const SectionHeading = ({
  index,
  eyebrow,
  title,
  testId,
}: {
  index: string;
  eyebrow: string;
  title: string;
  testId: string;
}) => (
  <div className="mb-14 md:mb-20">
    <Reveal>
      <div className="mb-6 flex items-center gap-4">
        <span className="font-sans text-xs text-if-gold">{index}</span>
        <span className="h-px w-10 bg-if-gold/40" />
        <span className="text-[11px] uppercase tracking-[0.3em] text-if-gold/80">
          {eyebrow}
        </span>
      </div>
    </Reveal>
    <h2
      data-testid={testId}
      className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-if-text sm:text-5xl lg:text-6xl"
    >
      <MaskedWords text={title} />
    </h2>
  </div>
);
